


















































































































































































































































import Vue from "vue"
import MarkdownItVue from 'markdown-it-vue'
// import 'markdown-it-vue/dist/markdown-it-vue.css'

import JobConfigPicker from './JobConfigPicker.vue'
import KeyStorageSelector from './KeyStorageSelector.vue'

import AceEditor from '../utils/AceEditor.vue'
import PluginPropVal from './pluginPropVal.vue'
import { client } from '../../modules/rundeckClient'
import DynamicFormPluginProp from "./DynamicFormPluginProp.vue";
export default Vue.extend({
  components:{
    DynamicFormPluginProp,
    AceEditor,
    JobConfigPicker,
    MarkdownItVue,
    PluginPropVal,
    KeyStorageSelector
  },
  props:{
    'prop':{
      type:Object,
      required:true
     },
    'value':{
      required:false,
      default:''
     },
    'inputValues':{
      type:Object,
      required:false
     },
    'validation':{
      type:Object,
      required:false
     },
    'rkey':{
      type:String,
      required:false,
      default:''
     },
    'pindex':{
      type:Number,
      required:false,
      default:0
     },
    'descriptionCss':{
        type:String,
        default:'',
        required:false
    },
    'extendedCss':{
        type:String,
        default:'',
        required:false
    },
    'contextAutocomplete':{
        type:Boolean,
        default:false,
        required:false
    },
  },
  methods:{
    inputColSize(prop: any) {
      if (prop.options && prop.options['selectionAccessor']) {
        return 'col-sm-5'
      }
      return 'col-sm-10'
    },
    setJobName(jobUuid: string) {
      if((jobUuid && jobUuid.length > 0) && (this.prop.options && this.prop.options['displayType']==='RUNDECK_JOB')) {
        client.jobInfoGet(jobUuid).then(response => {
          if(response.name) {
            var output = ''
            if(response.group) output += response.group+"/"
            output += response.name + " ("+response.project+")"
            this.jobName = output
          }
        })
      }
    },
    parseAllowedValues(){
      return JSON.stringify(this.prop.allowed);
    },
    hasAllowedValues(){
      if(this.prop.allowed!=null){
        return 'true';
      }
      return 'false';
    }
  },
  data(){
    return{
      currentValue: this.value,
      jobName: '',
      keyPath:'',
    }
  },
  watch:{
    currentValue:function(newval){
      this.$emit('input',newval)
      this.setJobName(newval)
    },
    value:function(newval){
      this.currentValue = newval
    }
  },
  computed:{
    shortDescription() :string{
      const desc = this.prop.desc
        if (desc && desc.indexOf("\n") > 0) {
            return desc.substring(0, desc.indexOf("\n"));
        }
        return desc;
    },
    extraDescription() :string|null{
      const desc = this.prop.desc
        if (desc && desc.indexOf("\n") > 0) {
            return desc.substring(desc.indexOf("\n") + 1);
        }
        return null;
    }
  },
  mounted(){
    this.$emit("pluginPropsMounted")
    this.setJobName(this.value)
    if (window._rundeck && window._rundeck.projectName) {
      this.keyPath = 'keys/project/' + window._rundeck.projectName +'/'
    }
  }
})
